import { useTheme } from "next-themes";
import { themeBasedAccordion } from "./customStyles";

function Accordion({ data }) {
  const { theme } = useTheme();

  return (
    <div
      className='col-12 px-1 accordion accordion-flush mt-2'
      id='faqAccordion'
      style={{
        ...themeBasedAccordion(theme),
      }}
    >
      {data.map((item, index) => {
        return (
          <div
            className='accordion-item position-relative'
            key={index}
            style={{
              color: theme === "light" ? "rgba(0,0,0,.9)" : "rgba(255,255,255,.8)",
            }}
          >
            <div
              className='position-absolute side-bar'
              style={{
                top: "0",
                bottom: "0",
                left: "0",
                width: "5px",
                borderRadius: "1.5rem",
                backgroundColor: theme === "light" ? "rgb(203, 110, 209)" : "rgb(78, 112, 237)",
                zIndex: "100",
                transition: "background-color 0.2s ease-in-out",
              }}
            ></div>
            <h2 className='accordion-header'>
              <button
                className='accordion-button accordion-btn-adjust collapsed ps-4'
                type='button'
                data-bs-toggle='collapse'
                data-bs-target={`#flush-collapse${index + 1}`}
                aria-expanded='false'
                aria-controls={`flush-collapse${index + 1}`}
                style={{
                  border: "none",
                  ["-bs-accordion-btn-color"]: theme === "light" ? "rgb(0,0,0)" : "rgb(255,255,255)",
                  ["--bs-accordion-active-color"]: theme === "light" ? "rgb(0,0,0)" : "rgb(255,255,255)",
                }}
              >
                {item.question}
              </button>
            </h2>
            <div id={`flush-collapse${index + 1}`} className='accordion-collapse collapse' data-bs-parent='#faqAccordion'>
              <div
                className='accordion-body ps-4'
                style={{
                  color: theme === "light" ? "rgb(0, 0, 0, 0.6)" : "rgba(255,255,255,.6)",
                  padding: "0.9rem 1.25rem !important",
                  fontWeight: "500",
                }}
              >
                {item.answer}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default Accordion;
